import { render, staticRenderFns } from "./panel-picture-alt.vue?vue&type=template&id=60cc4a0c&scoped=true&"
import script from "./panel-picture-alt.vue?vue&type=script&lang=js&"
export * from "./panel-picture-alt.vue?vue&type=script&lang=js&"
import style0 from "./panel-picture-alt.vue?vue&type=style&index=0&id=60cc4a0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc4a0c",
  null
  
)

export default component.exports